import TabTemplate from '../../html/components/tab.html'
import TabListTemplate from '../../html/components/tab-list.html'

import Component from '../shared/component'

import {InteractiveMixin} from './interactive'

export const Tab = Component('v-tab', {
  mixins: [
    InteractiveMixin
  ],
  template: TabTemplate,
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})

export const TabList = Component('v-tab-list', {
  template: TabListTemplate
})
